<mat-grid-list [cols]="loadAdmaker()?3:2" rowHeight="100px">
  <mat-grid-tile>
    <h4>Select {{ themetype}} Theme</h4>&nbsp;&nbsp;
    <mat-form-field>
      <mat-label>Select {{ themetype}} Theme</mat-label>
      <mat-select [(value)]="selectedTheme">
        <mat-option *ngFor="let theme of themes" [value]="theme.id">
          {{theme.name}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </mat-grid-tile>
  <mat-grid-tile *ngIf="loadAdmaker()">
    <button (click)="getAllAdConfigs()" class="btn btn-primary" style="border-radius:47%;">
      <mat-icon style=" position: relative; top: 3px;color:white;">replay</mat-icon>
    </button>
  </mat-grid-tile>
  <mat-grid-tile>
    <h4 *ngIf="themetype=='custom'">Select Client</h4> &nbsp;&nbsp;

    <mat-form-field *ngIf="themetype=='custom'">
      <mat-label>Select Client</mat-label>
      <mat-select [(value)]="selectedClient">
        <mat-option *ngFor="let c of clientList" [value]="c.clientID">{{c.name}}</mat-option>

      </mat-select>
    </mat-form-field>

  </mat-grid-tile>
</mat-grid-list>

<!--selected Clinet = Client is {{themetype}} + {{selectedTheme}}-->
<mat-tab-group (selectedTabChange)="change_tab($event)" *ngIf="loadAdmaker()">

  <mat-tab *ngFor="let sets of newsettings">
    <ng-template mat-tab-label>
      <span [matBadge]="getAdLenghthFromSettings(sets.settings)" matBadgeOverlap="false">{{sets.type}}</span>
    </ng-template>

    <mat-horizontal-stepper class="step_admaker" #stepper (selectionChange)="stepper_event($event)" *ngIf="confsReady && checkIsThere(sets.type) && Allelements.length>0">
      <mat-step [stepControl]="set.name" [label]="set.name" *ngFor="let set of sets.settings" [state]="'configg-'+set.id">
        <ng-template matStepLabel>
          <span [matTooltip]="set.name"> {{set.code}}</span>
        </ng-template>

        <span *ngFor="let o of getAd(set.id,selectedTheme);let in=index;">
          <app-admaker-tool [Allelements]="Allelements" [client]="selectedClient" [setting]="set" [currentOrder]="o.adOrder" [adConfid]="o.id" [adConftempid]="o.tempid" [myAd]="o.seedText" [isnew]="o.isNew" [nowTheme]="selectedTheme"></app-admaker-tool>
          <div class="add_order" *ngIf="getAd(set.id,selectedTheme).length==(in+1) && getAd(set.id,selectedTheme).length>0">
            <button class="btn btn-warning btn_add" (click)="addOrder(o.adOrder+1,set.id,selectedTheme)"> + Add AdConfig</button>

          </div>
        </span>
        <div class="add_order" *ngIf="getAd(set.id,selectedTheme).length==0">
          <button class="btn btn-warning btn_add" (click)="addOrder(1,set.id,selectedTheme)"> + Add AdConfig</button>

        </div>

        <div class="stepperControlBtn">

          <button class="btn btn-info bmain" matStepperPrevious>Back</button>
          <button class="btn btn-info bmain" matStepperNext>Next</button>




        </div>
      </mat-step>
      <ng-template *ngFor="let set of sets.settings;let la=index;" [matStepperIcon]="'configg-'+set.id">
        {{getAdLenghth(set.id,selectedTheme)}}
      </ng-template>
      <ng-template matStepperIcon="edit">
        {{getAdLenghth(00,selectedTheme,true)}}
      </ng-template>

    </mat-horizontal-stepper>

  </mat-tab>

</mat-tab-group>
